module.exports = __webpack_public_path__ + "assets/img/VisualizeData.dc40ef6a.png";